import React from 'react';
import PropTypes from 'prop-types';
import MoneyDisplay from '../money-display';

function MoneyRenderer(props) {
  const { data, value, precision } = props;
  if (data === null) {
    return null;
  }
  return (
    <MoneyDisplay value={value} abbreviated precision={precision} />
  );
}

MoneyRenderer.propTypes = {
  value: PropTypes.number,
  precision: PropTypes.number,
};
MoneyRenderer.defaultProps = {
  value: null,
  precision: 0,
};

export default MoneyRenderer;
